<template>

    <keep-alive>
         <router-link :to="to" class="news-item d_f">
            <img :src="img" alt="" class="left">
            <div class="content d_f d_f_c jc_sb">
                <div>
                    <h2 class="P_l">{{title}}</h2>
                    <p class="P_m">{{desc}}</p>
                </div>
                <span>{{date}}</span>
            </div>
            <img :src="img" alt="" class="right">
        </router-link>
    </keep-alive>
</template>


<script>
export default {
    props : {
        tag : Boolean,
        img : String ,
        title : String ,
        desc : String ,
        date : String ,
        min : {
            type : Boolean,
            default: function () {
                return false
            }
        },
        to: String,
    }
}
</script>

<style lang="scss" scoped>
    .news-item{
        width: 100%;
        padding: 40px 0;
        border-bottom: 1px solid #D8D8D8;
        img{
            width: 303px;
            height: 187px;
        }
        .content{
            flex: 1;
            margin-left: 30px;
            span{
                text-align: right;
            }
            h2{
                margin-bottom: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            p{
                height: 110px;
                margin: 0;
                overflow: hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-line-clamp: 5;
                // -webkit-box-orient: vertical;
            }
        }
        .left{
            display: block;
        }
        .right{
            display: none;
        }
    }

    @media screen and (max-width: 750px){
       .news-item{
           background-color: #fff;
           padding: 5.319vw;
           border-bottom: none;
           border-radius: 1.33vw;
           margin-bottom: 5.319vw;
           img{
               width: 31.915vw;
               height: 16.755vw;
           }
           .content{
                margin-right: 30px;
                margin-left:0 !important;
                h2{              
                    font-size: 3.191vw;
                    height: 10.106vw;
                    margin-bottom: 0.319vw;
                }
                p{
                    display: none;
                }
                span{
                    text-align: left;
                }
           }
           .left{
                display: none !important;
            }
            .right{
                display: block !important;
            }
       } 
    }


</style>